import { useEffect, useRef, useState } from "react";
import { loadQueue, saveQueue, type QueuedMessage } from "./QueueStack";

export function useChatQueue(chatId: string | null) {
  const [queue, setQueue] = useState<QueuedMessage[]>(() =>
    chatId ? loadQueue(chatId) : []
  );
  const queueChatIdRef = useRef<string | null>(chatId);

  useEffect(() => {
    if (!chatId) return;
    const previousChatId = queueChatIdRef.current;
    if (previousChatId === chatId) {
      saveQueue(chatId, queue);
      return;
    }
    if (previousChatId === null) {
      queueChatIdRef.current = chatId;
      setQueue(loadQueue(chatId));
      return;
    }
    queueChatIdRef.current = chatId;
    saveQueue(previousChatId, []);
    saveQueue(chatId, queue);
  }, [chatId, queue]);

  return [queue, setQueue] as const;
}
